import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page_header d-block" }
const _hoisted_2 = { class: "formContainer h-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: "h1",
        localizedKey: "Edit Footwear Configuration",
        text: "Edit Footwear Configuration"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.model.name) + " ", 1),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.model.materialCategories) + " ", 1),
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.model.footwearTypes), 1)
    ])
  ], 64))
}